import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RxAskPasswordComponent } from './rx-ask-password.component';
import { RxUiModule } from '@nrwl/rx-ui';
import { ReactiveFormsModule } from '@angular/forms';
import { RxIconModule } from '@nrwl/rx-icon';

@NgModule({
  imports: [CommonModule, RxUiModule, ReactiveFormsModule, RxIconModule, RxAskPasswordComponent],
  exports: [RxAskPasswordComponent],
})
export class RxAskPasswordModule {}
